import { formatBytes, ImagesViewer as SharedImagesViewer } from '@zg-rentals/satellite-components';
import { useAuth } from '../../AuthProvider';
import useModal from '../../hooks/useModal';
import stringUtils from '../../utils/stringUtils';
import type { AttachmentsForMessage } from '../MessageAttachments';
import type { TriggerLocation } from '../../constants/clickstreamEvents/globals';
import {
  emitIrenePreviewAttachmentsEvent,
  IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID,
} from '../../constants/clickstreamEvents/attachment';

export type Props = {
  imageAttachments: AttachmentsForMessage;
  selectedImageIndex: number;
  listingAlias: string;
  leadId?: string | null;
  triggerLocation: TriggerLocation;
};

const ImagesViewer = ({ imageAttachments, selectedImageIndex, listingAlias, leadId, triggerLocation }: Props) => {
  const { user } = useAuth();
  const { clearModal } = useModal();

  const handlePreviewAttachmentClick = () => {
    emitIrenePreviewAttachmentsEvent({ user, listing: { listingAlias }, triggerLocation, lead: { leadId } });
  };

  return (
    <SharedImagesViewer
      imageAttachments={imageAttachments}
      selectedImageIndex={selectedImageIndex}
      onClose={clearModal}
      onPreviewAttachmentClick={handlePreviewAttachmentClick}
      previewAttachmentEventId={IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID}
      formatFileName={stringUtils.capitalize}
      formatFileSize={formatBytes}
    />
  );
};

export default ImagesViewer;
